import Vue from 'vue';
import moment from 'moment';
import {
  ValidationProvider,
  ValidationObserver,
  extend,
  configure,
} from 'vee-validate';

import * as rules from 'vee-validate/dist/rules';
import { messages } from 'vee-validate/dist/locale/en.json';

const requiredRules = new Set([
  'email',
  'required',
  'integer',
  'numeric',
  'min',
  'alpha',
  'max',
  'min_value',
  'max_value',
]);

Object.keys(rules).forEach((rule) => {
  if (requiredRules.has(rule)) {
    extend(rule, {
      ...rules[rule],
      message(field, args) {
        field = field.replace(/_/g, ' ');
        let message = messages[rule];
        if (typeof args === 'object') {
          for (let arg in args) {
            if (!arg.startsWith('_')) {
              message = message.replace('{' + arg + '}', args[arg]);
            }
          }
        } else {
          message = message.replace(`{${args}}`, args);
        }
        return message.replace('{_field_}', field);
      },
    });
  }
});

const config = {
  classes: {
    valid: 'is-valid',
    invalid: 'is-invalid',
  },
  bails: true,
  skipOptional: true,
  mode: 'eager',
  useConstraintAttrs: true,
};

// Sets the options.
configure(config);

extend('confirm', {
  params: ['target'],
  validate(value, { target }) {
    return value === target;
  },
  message: (field) =>
    `The ${field.replace(/_/g, ' ')} does not match the ${
      field.split('_')[0]
    } field`,
});

extend('object', {
  message: (field, args) =>
    `The ${field} ${
      args[0] === 'required' ? 'is required' : 'must be a valid object'
    }`,
  validate: (value, args) =>
    typeof value === 'object' &&
    (args[0] !== 'required' || Object.keys(value).length > 0),
});

extend('after', {
  message: (field, { target }) => {
    return `The ${field.replace(/_/g, ' ')} must be after ${target}`;
  },
  params: ['target', 'inclusion'],
  validate: (value, { target, inclusion }) => {
    if (!target || !moment(target).isValid()) {
      return false;
    }
    let diff = 1;
    if (inclusion) {
      diff = 0;
    }
    return moment(value).diff(moment(target), 'days') >= diff;
  },
});

extend('format', {
  message: (field, { format }) => {
    return `The ${field} must be in format ${format}`;
  },
  params: ['format'],
  validate: (date, { format }) => {
    return !(date && moment(date).format(format) !== date);
  },
});

extend('before', {
  message: 'The {_field_} must be before {date}',
  validate: (value, { date }) => {
    if (!date || !moment(date).isValid()) {
      return false;
    }
    let diff = 1;
    if (inclusion) {
      diff = 0;
    }
    return moment(date).diff(moment(value), 'days') >= diff;
  },
});

extend('location', {
  message: 'The {_field_} must be valid location(lat, lng)',
  validate: (value) => {
    let location = value.split(',');
    if (location.length !== 2) {
      return false;
    }
    if (
      location[0] < -85 ||
      location[0] > 85 ||
      location[1] < -180 ||
      location[1] > 180
    ) {
      return false;
    }
    return true;
  },
});

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
